import { AdacCheckbox } from '@adac-de/component-library';
import { withTracking } from '@utils/tracking/tracking';

export const Checkbox = withTracking(AdacCheckbox);
